import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { updateProfile } from '../services/api';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { FiPackage, FiRefreshCw, FiUser } from 'react-icons/fi';

export default function ProfilePage() {
  const { user } = useAuth();
  const [form, setForm] = useState({ name: user?.name || '', phone: user?.phone || '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateProfile(form);
      toast.success('Profile updated!');
    } catch {
      toast.error('Update failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <h1 className="font-display text-4xl font-bold text-yamass-black mb-8">My Profile</h1>

      {/* Quick links */}
      <div className="grid grid-cols-2 gap-4 mb-8">
        <Link to="/orders" className="bg-yamass-cream rounded-2xl p-5 flex items-center gap-3 hover:shadow-md transition-shadow">
          <FiPackage size={22} className="text-yamass-accent" />
          <div>
            <p className="font-semibold text-yamass-black text-sm">My Orders</p>
            <p className="text-xs text-gray-400">Track & manage</p>
          </div>
        </Link>
        <Link to="/orders" className="bg-yamass-cream rounded-2xl p-5 flex items-center gap-3 hover:shadow-md transition-shadow">
          <FiRefreshCw size={22} className="text-yamass-accent" />
          <div>
            <p className="font-semibold text-yamass-black text-sm">Returns</p>
            <p className="text-xs text-gray-400">View return status</p>
          </div>
        </Link>
      </div>

      {/* Profile form */}
      <div className="bg-yamass-cream rounded-2xl p-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-full bg-yamass-black flex items-center justify-center">
            <FiUser size={20} className="text-white" />
          </div>
          <div>
            <p className="font-semibold text-yamass-black">{user?.name}</p>
            <p className="text-sm text-gray-400">{user?.email}</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-xs text-gray-500 uppercase tracking-wider block mb-1">Full Name</label>
            <input
              value={form.name}
              onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
              className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-yamass-accent bg-white"
            />
          </div>
          <div>
            <label className="text-xs text-gray-500 uppercase tracking-wider block mb-1">Phone</label>
            <input
              value={form.phone}
              onChange={e => setForm(f => ({ ...f, phone: e.target.value }))}
              className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-yamass-accent bg-white"
            />
          </div>
          <div>
            <label className="text-xs text-gray-500 uppercase tracking-wider block mb-1">Email</label>
            <input value={user?.email} disabled className="w-full border border-gray-100 rounded-xl px-4 py-3 text-sm bg-gray-50 text-gray-400" />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="bg-yamass-black text-white px-8 py-3 rounded-full text-sm font-semibold hover:bg-yamass-accent transition-colors disabled:opacity-50"
          >
            {loading ? 'Saving...' : 'Save Changes'}
          </button>
        </form>
      </div>
    </div>
  );
}
